import React, { Component } from "react";
import axios from "../../axios";
import Alert from "react-s-alert";
import qs from 'qs';
import moment from "moment";
import Parser from 'html-react-parser';
import { NavLink } from "react-router-dom";
import Pembayaran from "./Pembayaran";

const NewDate    = moment().format('YYYY-MM-DD')

class Keuangan extends Component {
	constructor(props) {
		super(props);

		this.state = {
            dataReport: [],
            total_debet:0,
            total_kredit:0,
            total_balance:0,
            siswa_id:"",
            finance_misc:"",
            finance_name:"",
            nominal_balance:"",
			user_id: "",
			date: "",
			created_by:"",
			isButtonLoading: false,
			isLoading   : false,
		};

		this.handleChange = this.handleChange.bind(this);
		this.toggleModal = this.toggleModal.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

    toggleModal(e) {
        this.setState({
            modalShow: !this.state.modalShow
        });
    }

	handleChange(event) {
		const target = event.target;
		const value = target.type === "checkbox" ? target.checked : target.value;
		const name = target.name;

		this.setState({
			[name]: value
		});
    }
    
    handleSubmit() {
        let formData = new FormData();
        const config = {
			headers: { "content-type": "multipart/form-data" }
		};

		formData.append("created_by", localStorage.SISMART_USER_ID);
		formData.append("master_id", this.state.master_id);
		formData.append("group_id", this.state.group_id);
		formData.append("master_tgl_jatuh_tempo", this.state.master_tgl_jatuh_tempo);
		formData.append("tipe_id", this.state.tipe_id);
		formData.append("master_nominal", this.state.master_nominal);

		const url = this.props.mode === "Tambah" ? "/iuran/master/add" : "/iuran/master/update";

		this.setState({ isButtonLoading: true });

		axios.post(url, formData, config)
			.then(response => {
                
				const result = response.data;

				if (result.success) {
					Alert.success(result.message);
					this.props.history.replace("/diskoniuran");
				} else {
					if (Array.isArray(result.message)) {
						result.message.map(item => {
							Alert.error(item);

							return true;
						});
					} else {
						Alert.error(result.message);
					}

					this.setState({ isButtonLoading: false });
				}
			})
			.catch(error => {
				console.log("ERROR", error);
				Alert.error("Gagal terhubung ke server!");
				this.setState({ isButtonLoading: false });
			}); 
	}

	loadData() {
		this.setState({isLoading: true, isButtonLoading: true})
        
        // alert(this.props.match.params.user_nama)
        const params = qs.stringify({
            siswa_id: this.props.match.params.siswa_id,
        })

        axios.get("/siswa/finance/balance?" + params)

            .then(response => {
                const result = response.data

                if (result.success === true) {
                    this.setState({
                        dataReport: result.data,
                        total_debet: result.total_debet,
                        total_kredit: result.total_kredit,
                        total_balance: result.total_balance,
                        isLoading: false,
                        isButtonLoading: false
                    });
                } else {
                    Alert.error(result.message);
                    this.setState({isLoading: false});
                }

            })

            .catch(error => {
                this.setState({isLoading: false});
                Alert.error("Gagal terhubung ke server!");
            });
    }
    
	
	componentDidMount() {
		this.loadData();
	}

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.location.search !== this.props.location.search || 
            prevState.kelas_id !== this.state.kelas_id) {
            this.loadData()
        }
    }

	render() {
		return (
			<div className="col-sm-12">
                <Pembayaran
                    modalHeaderText="Pembayaran"
                    modalBodyText = ""
                    modalSubmitText="Bayar"
                    finance_name = {this.state.finance_name}
                    nominal_balance = {this.state.nominal_balance}
                    siswa_id = {this.state.siswa_id}
                    finance_misc= {this.state.finance_misc}
                    toggleModal={this.toggleModal}
                    isShow={this.state.modalShow}
                />
				<div className="card">
                    <div className="card-header">
                        Keuangan
                    </div>
                    <div className="card-block">
                            <div className="col-md-8">
                                <label className="form-control-label"style={{marginTop:3}}>Kelas : {atob(this.props.match.params.kelas_nama)}</label>
                            </div>
                            <div className="col-md-8">
                                <label className="form-control-label">Siswa : </label> <label>{atob(this.props.match.params.user_nama)}</label>
                            </div>
                        {
                            this.state.isLoading ? "Memuat Data..." : (
                                this.state.dataReport.length === 0 ? "Data tidak ditemukan..." : (
                                    <div>
                                        <table className="table table-striped table-bordered animated fadeIn table-responsive">
                                            <thead>
                                            <tr>
                                                <th>Finance</th>
                                                <th>Tipe</th>
                                                <th>D</th>
                                                <th>K</th>
                                                <th>Nominal Debet</th>
                                                <th>Nominal Kredit</th>
                                                <th>Status</th>
                                                <th>Nominal Balance</th>
                                                <th>Tanggal Bayar</th>
                                                <th>Action</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                this.state.dataReport.map((item, i) => {

                                                    return (
                                                        console.log(item.finance_name),
                                                        <tr key={i++}>
                                                            <td>{item.finance_name}</td>
                                                            <td>{item.finance_tipe}</td>
                                                            <td>{item.finance_debit}</td>
                                                            <td>{item.finance_kredit}</td>
                                                            <td>{item.nominal_debet}</td>
                                                            <td>{Parser(""+item.nominal_kredit)}</td>
                                                            <td>{item.finance_status}</td>
                                                            <td>{item.nominal_balance}</td>
                                                            <td>{Parser(""+item.payment_date)}</td>
                                                            <td>
                                                                {/* <NavLink to={`${this.props.match.url}/bayar/${item.finance_id}`}
                                                                className="btn btn-primary btn-sm"
                                                                style={{margin: 3,
                                                                borderRadius:3}}>Bayar</NavLink> */}
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger btn-sm"
                                                                    hidden = {item.finance_status === "Lunas"?true:false || item.finance_kredit === "K"?true:false}
                                                                    onClick={() => {
                                                                        this.toggleModal();
                                                                        this.setState({ siswa_id:this.props.match.params.siswa_id,
                                                                                        finance_name:item.finance_name,
                                                                                        nominal_balance:item.nominal_balance,
                                                                                        finance_misc:item.finance_misc
                                                                        });
                                                                    }}
                                                                >
                                                                    Pembayaran
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                            </tbody>
                                        </table>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <th>Total Debet (D)</th> <td> : </td> <td>{this.state.total_debet}</td>
                                                </tr>
                                                <tr>
                                                    <th>Total Kredit (K)</th> <td> : </td> <td>{this.state.total_kredit}</td>
                                                </tr>
                                                <tr>
                                                    <th>Total Balance</th> <td> : </td> <td>{this.state.total_balance}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        
                                    </div>
                                )
                            )
                        }

                    </div>
                </div>
			</div>
		);
	}
}

export default Keuangan;



// WEBPACK FOOTER //
// ./src/views/IuranSiswa/Keuangan.js